module.exports = __webpack_public_path__ + "img/summary_Image.f7f64dd9.png";